define(["Magento_Theme/js/is-desktop-width", "jquery"], function(isDesktopWidth, $) {
    "use strict";

    return function(Mage2LayerApi) {

        Mage2LayerApi.prototype = jQuery.extend(Mage2LayerApi.prototype, {

            scrollInit: function() {
                let hash = window.location.hash;

                if (!hash.length) {
                    return;
                }

                let iterations = 5,
                    wait = 500,
                    options = {
                        behavior: 'smooth'
                    };

                function scrollIfTargetLoaded() {
                    let $el = $(hash);

                    if ($el.length) {
                        // Get top of $element
                        options.top = $el.get(0).getBoundingClientRect().top + window.scrollY;

                        // Desktop has a floating nav bar that we need to offset
                        if (isDesktopWidth()) {
                            options.top -= 100;
                        }

                        // Scroll the window to the element
                        window.scrollTo(options);
                        iterations = 0;
                    }

                    if (iterations-- > 0) {
                        setTimeout(scrollIfTargetLoaded, wait);
                    }
                }

                scrollIfTargetLoaded();
            }
        });

        return Mage2LayerApi;
    };
});
